import { render, staticRenderFns } from "./display-field-date-time.vue?vue&type=template&id=5bccc281&scoped=true&"
import script from "./display-field-date-time.ts?vue&type=script&lang=ts&"
export * from "./display-field-date-time.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-date-time.scss?vue&type=style&index=0&id=5bccc281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bccc281",
  null
  
)

export default component.exports